module.exports = {};

module.exports.profile = {
  baseUrl: 'https://auth.staging.spotii.me/api/v1.0',
  endpoints: {
    register: '/merchant/',
    profile: '/merchant/profile/me/',
    company_profile: '/merchant/profile/company_general_information/',
    company_specific: '/merchant/profile/company_specific_information/',
    requestPhoneVerification: '/merchant/submit_phone_number/',
    requestEmailVerification: '/merchant/submit_email/', // ?
    setNewPasswordRequest: '/merchant/update_password_request/',
    setNewPasswordConfirm: '/merchant/update_password_request/{id}/',
    setNewEmail: '/merchant/set_new_email/',
    emailVerification: '/verification/email/{token}/',
    resendVerificationEmail: '/verification/email/',
  },
};

module.exports.registration = {
  baseUrl: 'https://auth.staging.spotii.me/api/v1.0',
  endpoints: {
    create: '/merchant/registration/',
    update: '{url}',
    validate: '{url}validate/',
    verify: '{url}verify/',
  },
};

module.exports.recovery = {
  baseUrl: 'https://auth.staging.spotii.me/api/v1.0',
  endpoints: {
    init: '/merchant/password-recovery-request/',
    confirmOtp: '{url}',
    setNewPassword: '{url}verify/',
  },
};
